import {Box, Grid, Theme, Typography} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React, {FC, memo} from 'react';
import {useSelector} from 'react-redux';
import {AppState} from '../../../../../state/store';
import {getUnitLengthNameByCulture} from '../../../../../utilities/helpers/culture-settings-helper';
import {getConfigurationParamByNameAndCulture} from '../../../../../utilities/helpers/product-helper';
import {TextInput} from '../../../default-components/form/text-input';
import {TextInputLabel} from '../../form/text-input-label';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formTextInputBox: {
      width: '250px',
      display: 'flex',
      justifyContent: 'center',
      [`& fieldset`]: {
        borderRadius: 0,
      },
    },
    unitText: {
      fontWeight: 'bold',
      alignSelf: 'center',
      marginLeft: 10,
    },
  }),
);

export interface PropsFromParent {
  formName: string;
  textInputLabel: string;
  hintLabel?: string;
  tooltipLabel: string;
  formOnBlur?: () => void;
  defaultValue?: string;
}

export const ValueInput: FC<PropsFromParent> = memo((props) => {
  const classes = useStyles();
  const {unitsId} = useSelector((store: AppState) => store.urlSettingsReducer.cultureUrlParameters);
  const selectedProduct = useSelector((store: AppState) => store.projectReducer.selectedProduct);

  return (
    <>
      <Grid item xs={7}>
        <TextInputLabel
          name={props.formName}
          label={props.textInputLabel}
          hintLabel={props.hintLabel && '(' + props.hintLabel + ')'}
          tooltipLabel={props.tooltipLabel}
        />
      </Grid>
      <Grid item xs={5}>
        <Box className={classes.formTextInputBox}>
          {
            <TextInput
              name={props.formName}
              defaultValue={getConfigurationParamByNameAndCulture(selectedProduct, props.formName, unitsId)}
              callbackOnBlur={props.formOnBlur}
            />
          }
          <Typography className={classes.unitText}>{getUnitLengthNameByCulture(unitsId)}</Typography>
        </Box>
      </Grid>
    </>
  );
});
